








































































import Vue, { PropType } from 'vue';
import { MountingPortal } from 'portal-vue';
import clickoutside from '@/directives/clickoutside';
import SvgIcon from '@/components/SvgIcon';
import { isMobile } from '@/utils/isMobile';
import { SelectOption, SelectOptions } from './types';
import {JSONParser} from "@/utils/JSONParser";
import { feedbackWidget } from '@/common/widgets';
import {ModalData} from "@/widgets/FeedbackWidget/types";

export default Vue.extend({
    name: 'MortgageDropDownList',

    model: {
        prop: 'value',
        event: 'change',
    },

    components: { MountingPortal, SvgIcon },

    props: {
        modalcallback: {},
        disabled: Boolean,
        upadateName: String,
        name: String,
        value: [String, Number, Object],
        options: {
            type: Array as PropType<SelectOptions>,
        },
        placeholder: String,
        dropdownAppendToBody: { type: Boolean, default: true },
    },

    data() {
        return {
            isMobile: isMobile(),
            showDropdown: false,
            focused: false,
            defaultname: "В ипотеку:"
        };
    },

    created() {
        if (this.dropdownAppendToBody) {
            const portal = document.createElement('div');
            portal.id = 'select' + (this as any)._uid;
            document.body.appendChild(portal);
            (this as any).portal = portal;
        }
    },

    computed: {
        label(): string | undefined {
            const selectedOption = this.options?.find(
                (option) => option.value == this.value
            );
            return selectedOption?.monthlypayment;
        },
        labelName(): string | undefined {
            const selectedOption = this.options?.find(
                (option) => option.value == this.value
            );
            return selectedOption?.label;
        },
    },

    methods: {
        funmodalcalback(){
            const parser = new JSONParser('js-feedback-widget-parser');
            const rawModalData = parser.parse<ModalData>(this.modalcallback);

            const modalData = Object.assign({}, rawModalData, {});
            feedbackWidget.show(modalData);
        },
        onOptionClick(option: SelectOption) {
            if (this.value != option.value) {
                this.$emit('change', option.value);
            }
            ///const priceOutput = document.querySelector('.passport-svg-price__price');
            ///const priceOldOutput = document.querySelector('.passport-svg-price__price-old');
            ///if(priceOutput){
            ///    priceOutput.innerHTML=option.price
            ///}
            ///if(priceOldOutput){
            ///     priceOldOutput.innerHTML=option.oldprice
            ///}
            //this.showDropdown = false;
        }
    }

});
